import { useEffect, useState } from 'react';
import { Button } from 'reactstrap';

import ModalBase from '../ModalBase/ModalBase';
import SubmitAQuestionForm from './components/SubmitAQuestionForm/SubmitAQuestionForm';
import SubmittedQuestionsList from './components/SubmittedQuestionsList/SubmittedQuestionsList';

function SubmitAQuestionView({
  user,
  submitNewQuestion,
  isUserQuestionsLoading,
  statusMessage,
  setUserQuestionsMessage,
  userSubmittedQuestions,
  getUserSubmittedQuestions,
  deleteUserSubmittedQuestion,
  setDeleteStatusMessage,
  deleteStatusMessage,
  setSelectedQuestion,
  selectedQuestion,
  editSubmitQuestion,
}) {
  const [isBlockSubmitModalOpen, setIsBlockSubmitModalOpen] = useState(false);

  const [questionToEditValues, setQuestionToEditValues] = useState({});
  const [questionToEditInputs, setQuestionToEditInputs] = useState({});

  useEffect(() => {
    getUserSubmittedQuestions();
  }, []);

  useEffect(() => {
    if (user.blockSubmitQuestion) {
      setIsBlockSubmitModalOpen(true);
    }
  }, []);

  const handleSetQuestionToEditValues = (values) => {
    setQuestionToEditValues(values);
  };

  const handleSetQuestionToEditInputs = (inputs) => {
    setQuestionToEditInputs(inputs);
  };

  const handleResetQuestionToEdit = () => {
    setQuestionToEditValues({});
    setQuestionToEditInputs({});
  };

  const closeBlockSubmitModal = () => {
    setIsBlockSubmitModalOpen(false);
  };

  return (
    <main className="submit__container">
      <SubmitAQuestionForm
        submitNewQuestion={submitNewQuestion}
        isUserQuestionsLoading={isUserQuestionsLoading}
        statusMessage={statusMessage}
        setUserQuestionsMessage={setUserQuestionsMessage}
        questionToEditValues={questionToEditValues}
        questionToEditInputs={questionToEditInputs}
        handleResetQuestionToEdit={handleResetQuestionToEdit}
        setSelectedQuestion={setSelectedQuestion}
        selectedQuestion={selectedQuestion}
        editSubmitQuestion={editSubmitQuestion}
      />
      <SubmittedQuestionsList
        userSubmittedQuestions={userSubmittedQuestions}
        isUserQuestionsLoading={isUserQuestionsLoading}
        deleteUserSubmittedQuestion={deleteUserSubmittedQuestion}
        setDeleteStatusMessage={setDeleteStatusMessage}
        deleteStatusMessage={deleteStatusMessage}
        handleSetQuestionToEditValues={handleSetQuestionToEditValues}
        handleSetQuestionToEditInputs={handleSetQuestionToEditInputs}
        handleResetQuestionToEdit={handleResetQuestionToEdit}
        setSelectedQuestion={setSelectedQuestion}
      />
      {isBlockSubmitModalOpen && (
        <ModalBase
          isOpen={isBlockSubmitModalOpen}
          toggle={closeBlockSubmitModal}
          centered
          backdrop="static"
          header="Oops!"
          body="You cannot submit any more questions at this time. Please contact an Administrator."
          footer={
            <Button color="primary" onClick={closeBlockSubmitModal}>
              Understood
            </Button>
          }
        />
      )}
    </main>
  );
}

export default SubmitAQuestionView;
